import { createStore, createLogger } from "vuex";
import qrcode from "./modules/qrcode";
import record from "./modules/record";
import auth from "./modules/auth";
import { QrcodeState } from "./modules/qrcode/state";
import { RecordState } from "./modules/record/state";
import { AuthState } from "./modules/auth/state";

const debug = process.env.NODE_ENV !== "production";

export interface State {
    qrcode: QrcodeState;
    record: RecordState;
    auth: AuthState;
}

const store = createStore<State>({
    modules: {
        qrcode,
        record,
        auth,
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
});

export default store;
